module.exports = __webpack_public_path__ + "static/media/donuts-milk.8cdea580.jpeg";